import { render, staticRenderFns } from "./banner-native.vue?vue&type=template&id=8be15828&"
import script from "./banner-native.vue?vue&type=script&lang=js&"
export * from "./banner-native.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/banner-native/banner-native.vue
// module id = 88
// module chunks = 0